import { call, put, select, takeEvery, takeLatest } from 'redux-saga/effects';

import { getDocs } from '../../services/apiCommon';
import * as common from '../sagasCommon';
import { TAX_EXEMPT_TYPE } from '../../constants/constant_doc_types';
import * as SagasType from '../../constants/constant_saga_types';
import * as api from '../../services/tax/apiTaxExemptType';

export function* fetchListTaxExemptTypeSaga(feathersApp) {
  yield takeLatest(
    'FETCH_LIST_TAX_EXEMPT_TYPE',
    callFetchListTaxExemptType,
    feathersApp,
  );
}

function* callFetchListTaxExemptType(feathersApp, action) {
  try {
    const { silent, filters } = action;

    yield common.showProgressListTable(silent);

    const params = {
      filters,
      list_type: TAX_EXEMPT_TYPE,
    };

    const { data: rows, total: total_rows } = yield call(
      getDocs,
      feathersApp,
      params,
    );

    yield call(common.doneListTable, { rows, total_rows });
  } catch (error) {
    yield common.showErrorListTable(error);
  }
}

export function* saveTaxExemptTypeSaga(feathersApp) {
  yield takeEvery('SAVE_TAX_EXEMPT_TYPE', callSaveTaxExemptType, feathersApp);
}

function* callSaveTaxExemptType(feathersApp, action) {
  try {
    const { tenant, user } = yield select();

    yield put({ type: 'SAVE_RECORD_INPROGRESS' });

    const params = { tenant, user, data: action.data };

    const result = yield call(api.saveTaxExemptType, feathersApp, params);

    yield common.doneSaveRecord(result, 'Tax Exemption Type was saved');
    yield put({
      type: SagasType.SIMPLE_FORM_SET_DATA,
      data: result,
    });
    yield callFetchListTaxExemptType(feathersApp, { silent: true });
  } catch (e) {
    yield common.showErrorSaveRecord(e);
  }
}

export function* deleteTaxExemptTypeFromListSaga(feathersApp) {
  yield takeEvery(
    'DELETE_TAX_EXEMPT_TYPE_FROM_LIST',
    callDeleteTaxExemptTypeFromList,
    feathersApp,
  );
}

function* callDeleteTaxExemptTypeFromList(feathersApp, action) {
  yield deleteTaxExemptType(feathersApp, action);
  yield callFetchListTaxExemptType(feathersApp, { silent: true });
}

function* deleteTaxExemptType(feathersApp, action) {
  try {
    yield put({ type: 'DELETE_RECORD_INPROGRESS' });

    const { id } = action;

    if (id) {
      const { tenant, user } = yield select();
      const params = { tenant, user, id };

      const result = yield call(api.deleteTaxExemptType, feathersApp, params);

      yield put({
        type: 'DELETE_RECORD_DONE',
        payload: { id, docType: TAX_EXEMPT_TYPE },
      });
      yield callFetchListTaxExemptType(feathersApp, { silent: true });

      return result;
    }
  } catch (error) {
    yield put({ type: 'DELETE_RECORD_ERROR', error });
  }
}

export function* deleteTaxExemptTypeSaga(feathersApp) {
  yield takeEvery(
    'DELETE_TAX_EXEMPT_TYPE',
    callDeleteTaxExemptType,
    feathersApp,
  );
}

function* callDeleteTaxExemptType(feathersApp, action) {
  yield deleteTaxExemptType(feathersApp, action);
  yield callFetchListTaxExemptType(feathersApp, { silent: true });
}

export function* fetchTaxExemptTypeForEditSaga(feathersApp) {
  yield takeEvery(
    'FETCH_TAX_EXEMPT_TYPE_BY_ID',
    callFetchTaxExemptTypeForEdit,
    feathersApp,
  );
}

function* callFetchTaxExemptTypeForEdit(feathersApp, action) {
  try {
    const { id } = action;

    if (id) {
      const { tenant, user } = yield select();
      const docType = TAX_EXEMPT_TYPE;

      yield put({
        type: 'FETCH_DATA_BY_ID_INPROGRESS',
        payload: { docType, id },
      });

      const params = { tenant, user, id };

      const data = yield call(api.fetchTaxExemptTypeById, feathersApp, params);

      yield common.doneDataById(data);
      yield put({
        data,
        type: SagasType.SIMPLE_FORM_SET_DATA,
      });
    }
  } catch (error) {
    yield put({ type: 'FETCH_DATA_BY_ID_ERROR', error: error });
  }
}
